























import { defineComponent, watch } from '@nuxtjs/composition-api';
import { useDropdown } from '~/features/dropdown';
import { useSortBy } from '~/features/sortBy';
// import { SortEnum } from '~/graphql-types.gen';
// import { Unpacked } from '~/types/utils';

export default defineComponent({
  name: 'SortProductsDropdown',
  props: {
    value: {
      type: null,
      default: undefined,
    },
  },
  setup(_, { emit }) {
    const { isOpen, toggle } = useDropdown();
    const { options, selectedOption } = useSortBy();

    watch(selectedOption, newValue => {
      emit('input', newValue);
      isOpen.value = false;
    });

    return {
      isOpen,
      toggle,
      options,
      selectedOption,
    };
  },
});
